import React, { Component, useState } from 'react';
import AuthForm from './AuthForm';
import Report from './Report/Report';
import MonthlyReport from './Report/MonthlyReport';
import CashFlowHistory from './CashFlow/History';
import Planner from "./Planner";
import TransactionsSyncNow from './TransactionsSyncNow';
import UserSettings from './Settings/UserSettings';
import FamilyInvite from "./Settings/FamilyInvite";

import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import { Navbar, NavbarBrand, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';

export function Home() {
	const [selected, setSelected] = useState('home');
	const [isAuthorized, setIsAuthorized] = useState(false);
	const [showSidebar, setShowSidebar] = useState(false);

	const handleOnAuthorized = () => {
		setIsAuthorized(true);
	};

	const handleSelect = (key) => {
		setSelected(key);
		setShowSidebar(false); // Close sidebar after selection (optional)
	};

	const handleSidebarOpen = () => setShowSidebar(true);
	const handleSidebarClose = () => setShowSidebar(false);

	return (
		<>
			<header>
				<Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
					<Button
						variant="outline-secondary"
						onClick={handleSidebarOpen}
						aria-label="Open navigation"
						className="me-2"
					>
						☰
					</Button>
					<NavbarBrand tag={Link} to="/">Budget</NavbarBrand>
				</Navbar>
			</header>

			<Offcanvas show={showSidebar} onHide={handleSidebarClose} backdrop="static">
				<Offcanvas.Header closeButton>
					<Offcanvas.Title>Меню</Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body>
					<Nav variant="pills" className="flex-column" activeKey={selected} onSelect={handleSelect}>
						<Nav.Item>
							<Nav.Link eventKey="home">Головна</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link eventKey="history" disabled={!isAuthorized}>Історія</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link eventKey="report" disabled={!isAuthorized}>Звіт за період</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link eventKey="monthly-report" disabled={!isAuthorized}>Звіт по місяцям</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link eventKey="plan" disabled={!isAuthorized}>План</Nav.Link>
						</Nav.Item>
						<Nav.Item>
							<Nav.Link eventKey="settings" disabled={!isAuthorized}>Налаштування</Nav.Link>
						</Nav.Item>
					</Nav>
				</Offcanvas.Body>
			</Offcanvas>

			{selected === 'home' && (
				<>
					<AuthForm onAuthorized={handleOnAuthorized} />
					{isAuthorized && (
						<>
							<br />
							<br />
							<TransactionsSyncNow onUpdated={() => { }} />
							<br />
							<FamilyInvite />
						</>
					)}
				</>
			)}
			{selected === 'history' && isAuthorized && <CashFlowHistory />}
			{selected === 'report' && isAuthorized && <Report />}
			{selected === 'monthly-report' && isAuthorized && <MonthlyReport />}
			{selected === 'plan' && isAuthorized && <Planner />}	
			{selected === 'settings' && isAuthorized && <UserSettings />}	
		</>
	);
}

export default Home;